import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ThumbsUp({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.9464 2.66663H13.9124C15.235 2.66663 16.1934 3.92752 15.8394 5.20191L14.877 8.66663H17.5492C19.8543 8.66663 21.4637 10.9503 20.6884 13.1211L19.2598 17.1211C18.786 18.4477 17.5294 19.3333 16.1207 19.3333H9.99992V18H16.1207C16.9659 18 17.7199 17.4686 18.0042 16.6726L19.4327 12.6726C19.8979 11.3701 18.9323 9.99996 17.5492 9.99996H13.1228L14.5547 4.84506C14.6727 4.42026 14.3533 3.99996 13.9124 3.99996H13.7201L9.72013 11H7.99992V20.6666H3.33325V19.3333H6.66659V9.33329H3.33325V7.99996H7.99992V9.66663H8.94637L12.9464 2.66663Z"
        fill={iconColor}
      />
    </Svg>
  );
}
